module.exports = __webpack_public_path__ + "static/media/Polygon 10.c00ca114.svg";